module.exports = __webpack_public_path__ + "img/img3.65702d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img3.png
// module id = 207
// module chunks = 0